module.exports = __webpack_public_path__ + "static/media/severe.7e55ceec.ogg";